import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private currentTheme: 'light' | 'dark' = 'light';

  constructor(@Inject(DOCUMENT) private document: Document) { }

  switchTheme(theme: 'light' | 'dark'){
    this.currentTheme = theme;
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement

    if(themeLink){
        themeLink.href = theme + '.css';
    }
  }

  getCurrentTheme(): 'light' | 'dark' {
    return this.currentTheme;
  }

}
